import { Address } from '../../../../shared/contract/address.contract';

export async function reverseGeocodeAddressAt(
  lat: number,
  lon: number,
  extractAddress: (result: google.maps.GeocoderResult) => Address,
): Promise<Address | null> {
  if (typeof google === 'undefined' || !google.maps) {
    return null;
  }

  try {
    const { results } = await new google.maps.Geocoder().geocode({ location: { lat, lng: lon } });
    const result = results?.[0];
    return result ? extractAddress(result) : null;
  } catch {
    return null;
  }
}
